<template>
	<div
		class="modal payment-notice-modal"
		:class="{ 'modal--dark': darkTheme }"
		@click="close"
	>
		<div class="modal-holder" @click.stop>
			<span class="modal-title">
				Minimum payment
			</span>
			<p>
				<span class="payment-notice-mark">
					$2
				</span>
				payment is needed to finish your transaction
			</p>
			<div class="modal-buttons">
				<span class="button single-button" @click="close">
					Ok
				</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PaymentNoticeModal',

	props: {
		darkTheme: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		close() {
			this.$emit('close')
		}
	}
}
</script>

<style lang="scss">
.payment-notice-modal p {
	margin: 0 0 16px;
}

.payment-notice-mark {
	font-weight: 700;
}
</style>
